// extracted by mini-css-extract-plugin
export var sliderSteps = "slider-steps-module--sliderSteps--7ccba";
export var step = "slider-steps-module--step--3543b";
export var stepActive = "slider-steps-module--stepActive--1b27c";